import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { AuthUserDto, AuthTenantDto } from '@cutlyft/zod-schemas';

interface AuthState {
  user: AuthUserDto | null;
  tenant: AuthTenantDto | null;
  accessToken: string | null;
  setAuth: (user: AuthUserDto, tenant: AuthTenantDto | null, accessToken: string) => void;
  clearAuth: () => void;
}

/**
 * Zustand auth store to manage the logged-in user, tenant, and accessToken.
 * Persisted in sessionStorage (tab-scoped session per REQUIREMENTS.md).
 */
export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      tenant: null,
      accessToken: null,
      setAuth: (user, tenant, accessToken) => set({ user, tenant, accessToken }),
      clearAuth: () => set({ user: null, tenant: null, accessToken: null }),
    }),
    {
      name: 'cutlyft-auth',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
